export const recordToMap = (data) => {
  const map = new Map()

  Object.entries(data).forEach(([key, value]) => {
    map.set(key, value)
  })

  return map
}
